export const getCleanRevertReason = (error) => {
    // Fallback to error.reason, error.message, or standard string representation
    let msg = error?.reason || error?.message || "Transaction failed";
    
    if (typeof msg === 'string') {
        // 1. Remove standard Solidity JSON-RPC prefix if present
        if (msg.includes("execution reverted:")) {
            msg = msg.split("execution reverted:")[1];
        }
        
        // 2. Strip any colons followed by a hex string (0x...)
        msg = msg.replace(/:\s*0x[a-fA-F0-9]+/g, '');
        
        // 3. Clean any standalone hex addresses/hashes left
        msg = msg.replace(/0x[a-fA-F0-9]+/g, '');
        
        // 4. Clean up any trailing/leading colons and whitespace
        msg = msg.trim().replace(/^:\s*|\s*:\s*$/g, '').trim();
    }
    
    return msg || "Transaction failed";
};
